/**
 * 计算形态完成后
 */
export default function Ending(R){

	return [
		// 空值填充
		{
			priority: 60000,
			condition: function(R) {
		    R.when( true );
		  },
		  consequence: function(R) {
		  	_.each(this.historyCodes, function(history){
					if (history.form.length == 0) {
						history.form.push({label: '-',className: 'empty'})
					}
				})
		    R.next();
		  }
		},
		// 回调封装
		{
			priority: 50000,
			condition: function(R) {
		    R.when( true );
		  },
		  consequence: function(R) {
		  	const history = _.map(this.historyCodes, (item) => ({
		  			form: item.form, 
		  			issue: item.issue, 
		  			codes: item.displayCode,
		  			draw_time: item.draw_time,
		  			issueClass: item.issueClass || ''
		  	}))
				this.done = {
					history,
					currentMethod: this.currentMethod,
					title: this.title
				}
		    R.stop();
		  }
		},
	]
}